<template>
  <div v-if="showCarousel" class="sticky-wrap">
    <div class="bg-secondary-wrapper">
      <VueSlickCarousel
        v-if="items.length > 0"
        class="carousel carousel-main"
        :dots="false"
        :arrow="false"
        :fade="true"
        ref="c1"
        :asNavFor="$refs.c2" :focusOnSelect="true">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          class="carousel-cell"
        >
          <img @click.prevent="showModal" :alt="buildTitle" :src="getImageSource(item)"/>
        </div>
      </VueSlickCarousel>
      <!--      <flickity-->
      <!--        id="main"-->
      <!--        ref="main"-->
      <!--        v-images-loaded="imgsLoaded"-->
      <!--        :class="flickityClass"-->
      <!--        :options="mainSliderOptions"-->
      <!--        class="carousel carousel-main"-->
      <!--      >-->
      <!--        <div-->
      <!--          v-for="(item, idx) in items"-->
      <!--          :key="idx"-->
      <!--          class="carousel-cell"-->
      <!--        >-->
      <!--          <img :alt="buildTitle" :src="getImageSource(item)"/>-->
      <!--        </div>-->
      <!--      </flickity>-->
    </div>

    <VueSlickCarousel
      v-if="items.length > 0"
      ref="c2"
      :asNavFor="$refs.c1"
      :centerMode="true"
      :slidesToShow="4"
      :focusOnSelect="true"
      :variable-width="true"
      class="carousel carousel-nav"
    >
      <div
        v-for="(item, idx) in items"
        :key="idx"
        :class="`carousel-cell image-${item.id}`"
      >
        <img :alt="buildTitle" :src="getImageSource(item)"/>
      </div>
    </VueSlickCarousel>

    <!--    <flickity-->
    <!--      id="sub"-->
    <!--      ref="sub"-->
    <!--      :class="flickitySubClass"-->
    <!--      :options="navigationSliderOptions"-->
    <!--      class="carousel carousel-nav"-->
    <!--    >-->
    <!--      <div-->
    <!--        v-for="(item, idx) in items"-->
    <!--        :key="idx"-->
    <!--        :class="`carousel-cell image-${item.id}`"-->
    <!--      >-->
    <!--        <img :alt="buildTitle" :src="getImageSource(item)"/>-->
    <!--      </div>-->
    <!--    </flickity>-->
  </div>
</template>

<script>
import Flickity from 'vue-flickity'
import imagesLoaded from 'vue-images-loaded'
import {mapGetters} from "vuex";
import "flickity-fade";
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: "BuildCarouselSync",
  props: ['customBuild', 'full', 'zoomModels'],
  components: {
    "Flickity": Flickity
  },
  directives: {
    imagesLoaded,
  },
  data() {
    return {
      show: false,
      mainSliderOptions: {
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        fade: true,
        on: {
          staticClick: () => {
            this.showModal()
          }
        },
      },
      navigationSliderOptions: {
        accessibility: true,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        cellAlign: this.$device.isMobile ? 'left' : 'center',
        on: {
          staticClick: (event, pointer, cellElement, cellIndex) => {
            event.preventDefault()
            this.changeSubSlider(cellIndex)
          },
          change: (index) => {
            this.changeMainSlider(index)
          },
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      preselected: 'build/preselected'
    }),
    buildTitle() {
      if (this.build) {
        return this.build.title
      }

      return ""
    },
    build() {
      return this.preselected?.build || null
    },
    sortedModels() {
      return this.zoomModels.sort((a, b) => {
        return a.price - b.price
      })
    },
    flickitySubClass() {
      return {
        'hidden-sub': !this.show
      }
    },
    flickityClass() {
      return {
        hidden: !this.show
      }
    },
    buildItem() {
      if (this.customBuild) {
        return this.customBuild
      }
      return this.build
    },
    items() {
      return this.buildItem.media.images.sort((a, b) => {
        return a.id - b.id
      })
    },
    showCarousel() {
      console.log("Build items", this.buildItem)
      return this.buildItem && this.buildItem.media.images.length > 0;
    }
  },
  mounted() {
    this.$root.$on('changeZoomBuild', data => {
      let build
      let model = this.sortedModels.find(item => {
        return item.id === data.build['model_id']
      })

      for (let item of model['builds']) {
        if (item['build_title'].id === data.title.id && data.color === null) {
          build = item
          break;
        } else if (item['build_title'].id === data.title.id && item.color.id === data.color.id) {
          build = item
          break;
        }
      }

      if (build) {
        this.$store.commit('build/setBuildForZoom', {...build})
        this.$store.commit('build/setBuildGroups', this.modelColorGroups(build))
        this.$store.commit('build/setBuildTitles', this.shortModelList(build))
        this.$store.commit('build/setNotRedirectFromZoom', true)
      }
    })
  },
  methods: {
    imgsLoaded() {
      this.show = true
      this.$nextTick(() => {
        let main = this.$refs.main
        let sub = this.$refs.sub
        main.reloadCells()
        sub.reloadCells()
        main.resize()
        sub.resize()
        main.rerender()
        sub.rerender()
      })
    },
    getImageSource(item) {
      if (item.hasOwnProperty('path')) {
        return item.path
      }

      return item
    },
    showModal() {
      if (this.buildItem) {
        this.$store.commit('build/setBuildForZoom', this.buildItem)
        if (this.full) {
          this.$store.commit('build/setBuildGroups', this.modelColorGroups())
          this.$store.commit('build/setBuildTitles', this.shortModelList())
          this.$store.commit('build/setNotRedirectFromZoom', true)
        }
        setTimeout(() => {
          this.$modal.show('your-bag-gallery')
        }, 100)
      }
    },
    shortModelList(build = null) {
      if (build === null) {
        build = this.build
      }
      let model = this.zoomModels.find(item => {
        return item.id === build['model_id']
      })
      return this.sortedTitles(model);
    },
    sortedTitles(model) {
      if (model.model !== 'Siryon') {
        return model.titles
      }

      let items = model.titles;
      let result = [];
      let sorting = ['Halo', 'Neon', 'Diode', 'Edition one', 'Frame Kit'];

      sorting.forEach(function (key) {
        let found = false;
        items = items.filter((item) => {
          if (!found && item.title === key) {
            result.push(item);
            found = true;
            return false;
          } else
            return true;
        })
      })
      return result
    },
    modelColorGroups(build = null) {
      if (build === null) {
        build = this.build
      }
      let model = {
        ...this.zoomModels.find(item => {
          return item.id === build['model_id']
        })
      }
      let groups = []
      let builds = []
      for (let group of model.groups) {
        groups.push({...group})
      }
      for (let build of model.builds) {
        builds.push({...build})
      }
      groups = groups.sort((a, b) => {
        return a.price - b.price
      })

      groups = groups.map(item => {
        item.colors = item.colors.filter(color => {
          let buildsWithThisColor = builds.filter(b => {
            return b['build_title'].id === build['build_title'].id
          })

          return buildsWithThisColor.filter(bs => {
            return bs.color.id === color.id
          }).length > 0
        });
        return item
      }).filter(group => {
        return group.colors.length > 0
      })

      return groups
    },
    changeMainSlider(index) {
      this.$refs.main.select(index, false, false)
    },
    changeSubSlider(index) {
      this.$refs.sub.select(index)
    },
    // selectSlide(index) {
    //   this.$refs.sub.select(index)
    //   this.$refs.main.select(index)
    // },
    resetBuild() {
      let ctx = this
      ctx.show = false;
      setTimeout(function () {
        if (!ctx.show) {
          ctx.show = true
        }
      }, 700)
    },
  },
  watch: {
    build: {
      handler: "resetBuild",
      deep: true
    }
  }
}
</script>

<style lang="scss">
.carousel {

  &.carousel-main {
    .slick-current .carousel-cell{
      opacity: 1 !important;
    }
    .carousel-cell {
      opacity: 0 !important;

      &.is-selected {
        opacity: 1 !important;
      }
    }
  }
}

.hidden {
  opacity: 0;
  max-height: 269px;
  overflow-y: hidden;
}

.hidden-sub {
  opacity: 0;
  max-height: 56px;
  overflow-y: hidden;
}

.bg-secondary-wrapper {
  background-color: #f8f8f8;
  border-radius: 10px;
  padding-bottom: 66%;
  position: relative;
  margin-bottom: 20px;

  .carousel-main {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}

.carousel-main {
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;

  .carousel-cell {
    width: 100%;
    padding-bottom: 66%;
    background-color: #f8f8f8;
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      z-index: 1;
      mix-blend-mode: darken;
    }
  }

  .flickity-button,
  .flickity-page-dots {
    display: none;
  }

  @media (max-width: 991px) {
    border-radius: 7px;
  }
}

.carousel-nav {
  .slick-track{
    display: flex;
    justify-content: center;
  }
  .slick-current .carousel-cell{
    border: 1px solid #a3a3a3;
  }
  .carousel-cell {
    width: 56px;
    min-width: 56px;
    max-width: 56px;
    height: 56px;
    position: relative;
    border: 1px solid transparent;
    background: #f8f8f8;
    box-sizing: border-box;
    border-radius: 7px;
    margin: 0 7px;
    cursor: pointer;

    &.is-selected{
      border: 1px solid #a3a3a3;
    }

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      z-index: 1;
      mix-blend-mode: darken;
    }
  }

  .flickity-button,
  .flickity-page-dots {
    display: none;
  }
}

@media (max-width: 991px) {
  .bg-secondary-wrapper {
    border-radius: 7px;
    margin-bottom: 14px;
  }
  .carousel-nav .carousel-cell:first-child {
    margin-left: 0;
  }
}

@media (max-width: 767px) {
  .carousel-main {
    margin-bottom: 16px;
  }
}
</style>
